export default {
  common: {
    home: '首页',
    product: '产品中心',
    service: '服务支持',
    cases: '成功案例',
    news: '新闻资讯',
    company: '关于我们',
    platform: '平台介绍',
    information: '行业资讯',
    language: '语言',
    chinese: '中文',
    english: '英文',
    stockCode: '股票代码',
    login: '登录',
    smartParking: '智慧停车',
    smartCharging: '智能充电',
    mobileApp: '移动应用',
    smartHardware: '智能硬件',
    smartParkingSystem: '智慧停车场管理系统',
    smartChargingSystem: '智能充电桩管理系统',
    eParking: 'e停宝',
    parkingHardware: '停车场硬件产品',
    enclosedParking: '封闭车场',
    parkingGuidance: '车位诱导',
    roadsideParking: '路内停车',
    chargingHardware: '充电桩硬件产品',
    chargingProducts: '充电桩产品',
    accessControlHardware: '门禁通道硬件产品',
    accessControlProducts: '门禁通道产品',
    accessControl: '门禁通道',
    aboutUs: '了解我们',
    downloadCenter: '下载中心',
    contactUs: '联系我们',
    companyProfile: '公司简介',
    downloadMaterials: '资料下载',
    contactInfo: '联系方式',
    scenarioSolutions: '场景级解决方案',
    parkingChargingSolution: '停充一体运营增收方案',
    unmannedParkingSolution: '停车场无人值守云托管方案',
    companyName: '北京车易付科技股份有限公司',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    addressDetail: '北京市海淀区西北旺东路10号院东区17号楼中电金信大厦二层',
    productCenter: '产品中心',
    followUs: '关注我们',
    officialAccount: '公众号',
    beianInfo: '京公网安备 11010802045620号',
    icpInfo: '京ICP备2024085004号-1',
    serviceHotline: '服务热线'
  },
  home: {
    title: '欢迎来到车易付',
    subtitle: '专业的汽车金融解决方案提供商',
    banner1: '车易付是智慧停车与充电生态领军企业，提供从技术开发、技术服务到项目运营等一站式服务',
    banner2: '车易付的无人值守云托管方案，向停车场管理方提供的一种智慧停车场景建设及运营托管服务',
    banner3: '车易付的停充一体运营增收方案，为车主提供一站式"停车+充电"的便捷服务',
    banner4Alt: '车易付的云平台管理系统',
    getSolution: '点击获取方案',
    tryExperience: '点击立即体验',
    companyIntro: '公司简介',
    companyDetail: '北京车易付科技股份有限公司是新三板挂牌的北京市专精特新企业，股票代码：873063。公司集软硬件设计、研发、生产、销售、服务、运营于一体，持续服务行业十几年，是智慧停车和智能充电领域的开创者和引领者。\n\n公司始终坚持以技术为核心的全生态多维度发展，全力构建以云服务为依托的"城市+"智慧体系建设，积极拓展城市停车、城市充电及智慧社区、智慧物联、节能减排等新兴产业领域，为用户提供从技术开发、技术服务到项目运营等一站式服务。',
    ourProducts: '持续深耕的产品和服务',
    parkingService: '封闭车场服务',
    parkingDesc: '智慧车场+云平台的管理模式，降低车场运营成本、提升资源管理效率，并实现资产增值。通过精细化的管理，为车主提供高效、智慧、便捷的停车服务',
    serviceAdvantage: '服务优势',
    servicePoint1: '车场智能化改造，标准化运营',
    servicePoint2: '服务升级，全方位服务用户',
    servicePoint3: '数据智能分析，为运营决策提供支持',
    roadsideParking: '路内停车服务',
    roadsideParkingDesc: '依托云平台+智能硬件，对路内车位进行精细化的管理，实现车位监控、车位管理、车位巡检等功能。提升资源管理效率，为车主提供高效、智慧、便捷的停车服务',
    roadsideAdvantage1: '提升车位管控级别，资源合理利用',
    roadsideAdvantage2: '智能追缴提升停车缴费率',
    roadsideAdvantage3: '车位巡检提升管理效率，降低运营成本',
    chargingService: '智能充电服务',
    chargingServiceDesc: '依托云平台，实现对充电桩的集中管控和远程操控。帮助运营商提升运营效率、降低成本，同时为用户提供便捷、透明的充电服务',
    chargingAdvantage1: '提升充电桩管控级别，资源合理利用',
    chargingAdvantage2: '停车场+车位+充电桩精细化管理',
    chargingAdvantage3: '车主充电便捷，提升出行效率',
    accessControlService: '智慧门禁服务',
    accessControlServiceDesc: '从常规通行、集中管控、复杂通行等多方位打造高专业性的门禁管理服务',
    accessControlAdvantage1: '优化场所门禁管理，提升管理效率',
    accessControlAdvantage2: '全场景覆盖，方案灵活配置',
    accessControlAdvantage3: '解决人员信息难采集的难题',
    smartHardware: '智能化的硬件产品',
    parkingLot: '停车场',
    chargingEnergy: '充电储能',
    parkingLotHardware: '停车场智能硬件',
    parkingHardware: '停车场智能硬件',
    chargingHardware: '充电智能硬件',
    accessControlHardware: '门禁通道',
    ownPlatform: '自有平台',
    ownHardware: '自有硬件',
    parkingLotHardwareDesc: '提供停车场管理系统「控制机、道闸、外围产品等」以及停车位管理系统「停车诱导、车位引导、车位检测」等停车场全系智能硬件',
    parkingHardwareDesc: '提供停车场管理系统「控制机、道闸、外围产品等」以及停车位管理系统「停车诱导、车位引导、车位检测」等停车场全系智能硬件',
    chargingHardwareDesc: '提供充电桩、充电柜、充电管理系统等充电全系智能硬件',
    accessControlHardwareDesc: '提供访客门岗机、人行通道闸、门禁管理系统等人员通行全系智能硬件',
    knowMore: '了解更多',
    learnMore: '了解更多',
    viewMore: '查看更多',
    customerTrust: '客户的信任和支持',
    jiamusiProject: '佳木斯市静态交通综合治理项目',
    jiamusiProjectDesc: '黑龙江省佳木斯市通过构建覆盖全市的智慧停车平台，整合路内路外停车资源，集成智能感知设备与停充一体化管理，实现全域停车资源数字化治理。',
    heilongjiang: '黑龙江',
    guiyangProject: '贵阳经开区城市级停充一体化项目',
    guiyangProjectDesc: '贵阳经开区建设覆盖9800+车位的城市级停充一体化平台，整合路侧停车、封闭场库、快充场站资源，实现"管理-运营-数据-服务"全链条智能化。',
    guizhou: '贵州'
  },
  product: {
    title: '产品中心',
    description: '我们提供多样化的汽车金融产品',
    systemTitle: '无人值守，智慧停车场管理系统',
    systemAlt: '智慧停车云端管理平台',
    productOverview: '产品概述',
    productDesc: '车易付依托云平台，支持多个车场集中管控，集成车场远程运维监测、环境高清监控、车辆通行权限管控、多维度计费规则下发、车辆进出场智能语音播报、停车记录实时同步等功能，通过7*24小时远程值守坐席服务，秒级响应解决车场异常问题，确保车辆进出畅通无阻。\n\n车易付通过"硬件+云平台+服务"的业务模式，打造行业级的无人值守智慧停车场。',
    userPain: '用户痛点',
    painPoint1: '车场管理效率低',
    painDesc1: '传统停车场管理依赖人工，成本高且效率低',
    painPoint2: '安全保障不足',
    painDesc2: '传统停车场没有实时监控和值守客服，安全保障不足',
    painPoint3: '停车体验差',
    painDesc3: '车主寻找车场和车位困难，且支付方式繁琐，停车记录查找困难',
    painPoint4: '运营数据分析困难',
    painDesc4: '传统停车场运营数据分析困难，无法为运营决策提供支持',
    productFeatures: '产品功能',
    feature1: '车场智能管理',
    featureDesc1: '管理车场运营信息 、智能设备信息，下发停车计费规则，设置车场通道权限，设置车场出入口语音播报。',
    feature2: '远程智能运维',
    featureDesc2: '管理车场运营信息 采用现场秩序维护+24小时值守坐席的方式，实现远近结合，既能解决现场应急问题，同时也节约了车场的人工成本，达到降本增效的效果。',
    feature3: '车场协同运营',
    featureDesc3: '管理车场运营信息 针对车场开通的会员业务可在线办理，例如月卡车、年卡车、储值车、免费车、购买优惠券等服务。',
    feature4: '运营数据分析',
    featureDesc4: '管理车场运营信息 采用现场秩序维护+车场业务数据、财务数据、经营指标多维度动态智能分析，为停车场高效、准确、全面的经营决策提供支持。',
    acs: {
      title: '门禁通道',
      products: {
        swingGate: '摆闸',
        singleFullHeightTurnstile: '单门全高转闸',
        wingGate: '翼闸',
        tripodTurnstile: '三辊闸',
        faceRecognition: '人脸识别机',
        integratedAccessControl: '一体式门禁',
        singleDoorBiDirectionalController: '单门双向控制器',
        doubleDoorBiDirectionalController: '双门双向控制器',
        fourDoorUniDirectionalController: '四门单向控制器',
        cardIssuer: '发卡器',
        universalCardIssuer: '通用发卡器',
        cardReader: '读卡器',
        compositeCardReader: '复合读卡器',
        singleDoorMagneticLock: '单门磁力锁',
        doubleDoorMagneticLock: '双门磁力锁',
        doorOpenButton: '开门按钮',
        icIdCard: 'IC/ID卡',
        icIdKeyCard: 'IC/ID扣卡'
      }
    },
    applet: {
      title: 'e停宝',
      description: '车主可在e停宝小程序上快速精准查找车场信息、充电桩信息、价格信息、优惠信息、空闲状态，快捷导航指引车主便捷找到车场或充电桩，为车主提供停车、充电一体化服务。同时，e停宝还提供线上缴费、电子发票、车位承租、月卡续费、购买优惠券、订单查询等基础服务。',
      featuresTitle: '产品功能'
    },
    charge: {
      overviewTitle: '产品概述',
      overviewDescription: '依托云平台，实现对智能充电桩的集中监控、运营管理和优化服务。实时监控充电桩状态，远程控制充电桩。为用户提供充电导航、价格查询、订单记录等功能。帮助运营商提高运营效率，降低成本，为用户提供便捷透明的充电服务。',
      painPointsTitle: '用户痛点',
      painPoints: {
        lowEfficiency: '电站管理效率低',
        lowEfficiencyDesc: '电站管理依赖人工，成本高、效率低',
        insufficientSafety: '安全保障不足',
        insufficientSafetyDesc: '无法实现设备远程监控运维，安全保障不足',
        poorExperience: '充电体验差',
        poorExperienceDesc: '车主找电站、找充电桩困难，支付方式繁琐，充电记录难查询',
        dataAnalysisDifficulty: '运营数据分析难',
        dataAnalysisDifficultyDesc: '电站运营数据分析困难，无法为运营决策提供支持'
      },
      featuresTitle: '产品功能',
      features: {
        smartManagement: '智能电站管理',
        smartManagementDesc: '管理电站运营信息、充电桩设备信息，发布电站计费规则。',
        smartMaintenance: '智能电站维护',
        smartMaintenanceDesc: '远程控制充电桩的重启、停用等操作。支持设备告警工单的派发与跟踪，保障用户用电服务。',
        collaborativeOperation: '协同电站运营',
        collaborativeOperationDesc: '在线会员开通、充电卡申请、优惠券购买等服务。',
        dataAnalysis: '运营数据分析',
        dataAnalysisDesc: '对电站业务数据、财务数据、运营指标进行多维度动态智能分析，为停车场高效、精准、全面的业务决策提供支持。'
      }
    },
    chargeHw: {
      title: '智能充电',
      hardware: {
        dc30kw: '30KW直流桩',
        ac: '交流充电桩',
        dc: '直流充电桩',
        dualGun: '双枪充电终端柜',
        singleGun: '单枪充电终端柜',
        liquidCooled: '液冷储能柜',
        heavyTruck: '重卡直流充电桩',
        splitDc: '直流分体式充电堆',
        bikeRobot: '自行车充电机器人',
        eBike: '电动自行车充电桩',
        waterproofSocket: '防水插座'
      },
      alt: {
        dc30kw: '车易付30KW直流桩',
        ac: '车易付交流充电桩',
        dc: '车易付直流充电桩',
        dualGun: '车易付双枪充电终端柜',
        singleGun: '车易付单枪充电终端柜',
        liquidCooled: '车易付液冷储能柜',
        heavyTruck: '车易付重卡直流充电桩',
        splitDc: '车易付直流分体式充电堆',
        bikeRobot: '车易付自行车充电机器人',
        eBike: '车易付电动自行车充电桩',
        waterproofSocket: '车易付防水插座',
        banner: '车易付智能充电硬件展示'
      }
    },
    close: {
      tabs: {
        closePark: '封闭车场',
        guidance: '车位诱导',
        road: '路内停车'
      },
      labels: {
        new: '新品'
      },
      products: {
        standardUnmanned: '标准无人值守机',
        unmannedGuard: '无人值守卫士',
        licensePlateRecognition: '车牌识别一体机',
        ledLicensePlate: 'LED车牌识别',
        licensePlateBarrier: '车牌道闸一体机',
        integratedAuxiliary: '一体式辅机',
        vehicleTypeJudge: '车型判断器',
        barrierGate: '道闸',
        advertisingBarrier: '广告道闸',
        airBarrierHost: '空降闸主机',
        selfPayment: '自助缴费机',
        vacancyScreen: '余位屏',
        monitoringCamera: '监控相机',
        siteServer: '场地服务器',
        vehicleDetector: '车辆检测器',
        antiCrushRadar: '防砸雷达',
        parkingCamera: '车位相机',
        guidanceScreen: '引导屏',
        highCamera: '高位相机',
        smartParkingPile: '智慧停车视频桩',
        parkingLock: '车位锁',
        inspectionVehicle: '巡检车',
        handheldDevice: '手持机',
        geomagneticTerminal: '地磁终端'
      }
    }
  },
  // 客户案例
  case: {
    title: '客户案例',
    search: '搜索案例',
    noData: '暂无数据',
    loading: '加载中...',
    details: '查看详情',
    back: '返回列表'
  },
  service: {
    title: '服务支持',
    description: '我们提供全方位的服务支持',
    contactTitle: '联系方式',
    emailTitle: '官方邮箱',
    email: 'cheyifu@cheyifu.com.cn',
    businessTitle: '商务合作',
    businessPhone: '18601939795',
    serviceTitle: '服务热线',
    servicePhone: '400-623-9981',
    messageTitle: '在线留言',
    formName: '您的姓名',
    formContact: '联系方式',
    formAddress: '所在地址',
    formCompany: '公司名称',
    formRequirement: '项目需求',
    formMessage: '您的留言',
    checkbox1: '智慧停车方案',
    checkbox2: '智能充电',
    checkbox3: '门禁通道方案',
    checkbox4: '商务合作',
    checkbox5: '其他',
    submitBtn: '立即提交',
    requiredName: '请输入您的姓名',
    requiredPhone: '请输入联系方式',
    // 表单验证和提示信息
    formValidateName: '请输入您的姓名',
    formValidateContact: '请输入联系方式',
    formSubmitSuccess: '提交成功',
    formAlertTitle: '提示'
  },
  cases: {
    title: '成功案例',
    description: '了解我们的成功合作伙伴',
    case1Alt: '车易付静态交通治理项目：佳木斯静态交通中和治理项目',
    case1Title: '佳木斯市静态交通综合治理项目',
    case1Desc: '黑龙江省佳木斯市通过构建覆盖全市的智慧停车平台，整合路内路外停车资源，集成智能感知设备与停充一体化管理，实现全域停车资源数字化治理。',
    case1Address: '黑龙江',
    case2Alt: '车易付停充一体化项目',
    case2Title: '贵阳经开区城市级停充一体化项目​',
    case2Desc: '贵阳经开区建设覆盖9800+车位的城市级停充一体化平台，整合路侧停车、封闭场库、快充场站资源，实现“管理-运营-数据-服务”全链条智能化。',
    case2Address: '贵州'
  },

  company: {
    title: '关于我们',
    description: '了解车易付的发展历程和企业文化',
    introTitle: '公司简介',
    introDesc1: '北京车易付科技股份有限公司是新三板挂牌的北京市专精特新企业，股票代码：873063。公司集软硬件设计、研发、生产、销售、服务、运营于一体，持续服务行业十几年，是智慧停车和智能充电领域的开创者和引领者。',
    introDesc2: '公司始终坚持以技术为核心的全生态多维度发展，全力构建以云服务为依托的“城市+”智慧体系建设，积极拓展城市停车、城市充电及智慧社区、智慧物联、节能减排等新兴产业领域，为用户提供从技术开发、技术服务到项目运营等一站式服务。',
    valuesTitle: '价值观',
    visionTitle: '愿景',
    visionDesc: '成为最具竞争力的出行服务企业',
    missionTitle: '使命',
    missionDesc: '通过科技创新提升出行服务',
    valuesSubTitle: '价值观',
    valuesDesc: '诚信、感恩、团结、追求卓越',
    purposeTitle: '宗旨',
    purposeDesc: '让用户收益、让客户省心',
    agencyTitle: '企业资质',
    authorityTitle: '权威资质',
    authorityAlt: '权威资质',
    aboutTitle: '关于我们',
    aboutDesc: '公司通过互联网、物联网技术将智慧停车、智慧充电与政府、管理公司、赋能伙伴和车主有机结合到一起，打造安全、便捷舒适的智慧车辆生态系统。公司依托车易付云SaaS平台经验，于"物联网+AI"技术的自研分布无人值守机器人，基于"分差功率"技术的智能充电桩，目前覆盖城市达百余个，服务客户千余家',
    advantageTitle: '公司优势',
    professionalTitle: '我们的专业',
    professionalDesc: '公司主营业务涵盖城市智慧停车、智慧充电、智慧城市物联网、智慧民生服务及区域电商等多个领域的软件研发、硬件生产。公司通过互联网与物联网技术的整合将停车、充电、民生服务与政府、平台公司、业态伙伴和车主有机结合到一起。',
    teamTitle: '我们的团队',
    teamDesc: '全面的战术团队,为了应对多元化、智能化场景下的客户需求，车易付不仅拥有多场景复用的IOT平台、AI技术平台，车易付云SaaS平台，也配有行业资深管理团队、售前工程师、硬件团队，自研硬件产品的成本优势，可复制项目经验。',
    technologyTitle: '技术优势',
    technologyDesc: '技术创新立足之本 追求卓越提升体验，全产业链科学布局 协同并进共创未来 ，尖端人才群英荟萃 成果转化助力主业。',
    partnerTitle: '合作伙伴',
    honorTitle: '荣誉资质'
  },

  news: {
    title: '新闻资讯',
    description: '最新行业动态和公司新闻',
    all: '全部',
    companyNews: '企业动态',
    industryNews: '行业资讯',
    back: '返回'
  },
  platform: {
    title: '平台介绍',
    bannerAlt: '停充一体运营增收方案，为车主提供一站式"停车+充电"的便捷服务',
    solutionOverview: '方案概述',
    solutionDesc: '"场+位+桩"一体化精细能力，全方位解决目的地停车充电难问题。通过查桩找位、导航到位、充电车位精细管控杜绝占位，无感充电、停车场无人值守等措施，大幅提高车位&桩位周转和停充收益，增加场地方停车充电运营收入，为车主提供一站式"停车 + 充电"便捷服务。',
    fineManagement: '场+位+桩精细化管理',
    fineManagementAlt: '车易付停车充电精细化管理',
    solutions: '解决方案',
    efficientParkingControl: '车位高效管控',
    efficientParkingControlDesc: '车位停充一体，有效提高车位利用率',
    chargingParkingManagement: '充电车位托管',
    chargingParkingManagementDesc: '专业团队在线值守、7*24小时守护停充体验',
    flexibleCooperation: '合作模式灵活',
    flexibleCooperationDesc: '投建+运营、建设+代运营、现有桩接入运营',
    scientificInvestment: '科学投建测算',
    scientificInvestmentDesc: '数据测算车桩比、科学建投保收益',
    businessValue: '业务价值',
    comprehensiveCostReduction: '全面降本',
    comprehensiveCostReductionDesc1: '减人减岗，人力成本减少',
    comprehensiveCostReductionDesc2: '节能减耗，能耗成本低',
    comprehensiveCostReductionDesc3: '升级改造零投入/低成本',
    diversifiedIncome: '多元收入',
    diversifiedIncomeDesc1: '车位利用效益提升',
    diversifiedIncomeDesc2: '多元服务广泛增收',
    diversifiedIncomeDesc3: '层层堵漏全链追缴',
    longTermQualityImprovement: '长效提质',
    longTermQualityImprovementDesc1: '运营管理升级',
    longTermQualityImprovementDesc2: '多元服务广泛增收',
    longTermQualityImprovementDesc3: '车场形象升级',
    applicationScenarios: '应用场景',
    applicationScenariosAlt: '车易付停车充电应用场景',
    smartCity: '智慧城市',
    smartCommunity: '智慧社区',
    commercialComplex: '商业综合体',
    transportationHub: '交通枢纽',
    hospital: '医院',
    scenicSpot: '景区'
  },
  platformCloud: {
    solutionOverview: '方案概述',
    solutionDesc: '由车易付向停车场管理方提供的一种智慧停车场景建设及运营托管服务。车易付通过提供业界领先的"硬件+平台+服务"一站式服务，打造无人值守智慧车场，助力车场运营实现降本、提质、增收。',
    solutions: '解决方案',
    oneStopService: '一站式服务',
    oneStopServiceDesc: '硬件+平台+服务，打造无人值守一站式服务',
    intelligentOperation: '智能运维',
    intelligentOperationDesc: '现场秩序维护+后台值守坐席，全面保障车主快进快出',
    valueAddedOperation: '增值运营',
    valueAddedOperationDesc: '订单收入数据监控分析，科学决策运营',
    flexibleCooperation: '合作模式灵活',
    flexibleCooperationDesc: '多种合作模式，降低一次性投入的资金成本',
    businessValue: '业务价值',
    significantCostReduction: '大幅降本',
    significantCostReductionDesc1: '减人减岗，人力成本减少',
    significantCostReductionDesc2: '节能减耗，能耗成本低',
    significantCostReductionDesc3: '全面托管，免持续运维支出',
    significantIncomeIncrease: '大幅增收',
    significantIncomeIncreaseDesc1: '提升车位周转率，为车场增收',
    significantIncomeIncreaseDesc2: '支付电子化，无跑漏风险',
    significantIncomeIncreaseDesc3: '多种优惠策略运营，提升效益',
    longTermQualityImprovement: '长效提质',
    longTermQualityImprovementDesc1: '车主体验升级',
    longTermQualityImprovementDesc2: '运营管理升级',
    longTermQualityImprovementDesc3: '车场形象升级'
  },
  casesDetail: {
    projectIntroduction: '项目介绍',
    projectIntroductionDesc1: '黑龙江省佳木斯市通过构建覆盖全市的智慧停车平台，整合路内路外停车资源，集成智能感知设备与停充一体化管理，实现全域停车资源数字化治理。',
    projectIntroductionDesc2: '背景：作为老工业城市，佳木斯面临老城区停车资源紧张、充电设施匮乏、监管盲区多等问题，需通过智能化升级缓解市民停车难、提升交通效率。',
    projectPlan: '项目方案',
    globalIntelligentCoverage: '全域智能覆盖',
    globalIntelligentCoverageDesc: '接入100+停车场、3000+路内泊位（重点覆盖长安路等老城区），消除监管盲区',
    multimodalPerceptionTechnology: '多模态感知技术',
    multimodalPerceptionTechnologyDesc: '部署地磁、高低位视频桩等设备实时监测车位状态',
    parkingChargingIntegration: '停充一体化建设',
    parkingChargingIntegrationDesc: '改造新建4515个泊位，同步配套557套充电桩',
    contactlessPayment: '无感支付与追缴',
    contactlessPaymentDesc: '支持ETC停车支付及欠费高效追缴',
    advancedTechnologyIntegration: '先进技术融合',
    advancedTechnologyIntegrationDesc: '应用高位视频+低位视频桩+追缴车+标识标牌联动管理',
    parkingChargingCollaboration: '停充协同网络',
    parkingChargingCollaborationDesc: '建设5个快充场站（110把快充枪），满足新能源车快速补能',
    fullProcessClosedLoop: '全流程闭环服务',
    fullProcessClosedLoopDesc: '覆盖"建设-运营-维护-资产"全周期管理，响应政府智慧平台要求',
    // 贵阳经开区案例
    projectIntroduction2: '项目介绍',
    projectIntroductionDesc1_2: '贵阳经开区建设覆盖9800+车位的城市级停充一体化平台，整合路侧停车、封闭场库、快充场站资源，实现"管理-运营-数据-服务"全链条智能化。',
    projectIntroductionDesc2_2: '背景：响应贵阳市政府智慧城市建设要求，解决新能源汽车充电缺口大、停车资源分散、数据孤岛等问题，打造城市级静态交通样板。',
    projectPlan2: '项目方案',
    globalResourceIntegration: '全域资源整合',
    globalResourceIntegrationDesc: '路内路外9800+车位全覆盖接入，支持ETC支付及追缴',
    advancedTechnologyIntegration2: '先进技术融合​',
    advancedTechnologyIntegrationDesc: '应用高位视频+低位视频桩+追缴车+标识标牌联动管理',
    parkingChargingNetwork2: '停充协同网络',
    parkingChargingNetworkDesc: '建设5个快充场站（110把快充枪），满足新能源车快速补能',
    closedLoopService2: '全流程闭环服务',
    closedLoopServiceDesc: '覆盖"建设-运营-维护-资产"全周期管理，响应政府智慧平台要求'
  },
  information: {
    title: '行业资讯',
    description: '汽车金融行业相关资讯'
  }
}